<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addWhatToBring()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'ADD_WHAT_TO_BRING' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showWhatToBrings()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-what-to-bring-list
          [whatToBrings]="whatToBrings"
          [meta]="meta"
          [loadingWhatToBrings]="loadingWhatToBrings"
          [defaultLanguage]="defaultLanguage"
          (selectedWhatToBring)="onSelectedWhatToBring($event)"
        ></app-what-to-bring-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-what-to-bring-detail
        [whatToBring]="whatToBring"
        [mode]="mode"
        [defaultLanguage]="defaultLanguage"
        [additionalLanguages]="additionalLanguages"
        [isModal]="true"
        (savedWhatToBring)="onSavedWhatToBring($event)"
        (canceledWhatToBring)="onCanceledWhatToBring()"
      ></app-what-to-bring-detail>
    </div>
  </div>
</div>
